export interface AIFeaturesModel {
	conversationSummaryModelName: string;
	conversationSummarySystemMessage: string;
	conversationSummaryUserPrompt: string;
	conversationSummaryProvider: AiFeatureProvider;

	aiStepModelName: string;
	aiStepAssistant: string;
	aiStepProvider: AiFeatureProvider;

	aiAssistantResponseAssistant: string;
	aiAssistantResponseProvider: AiFeatureProvider;
}

export interface AIAssistant {
	id: string;
	name: string;
	usedByFeatures?: string[];
	usedByAgents?: string[];
}

export enum AiFeatureType {
	ConversationSummary = 0,
	AiStepPrompt = 1,
	AiAssistedResponse = 2,
}

export enum AiFeatureProvider {
	AzureOpenAI = 0,
	MicrosoftFoundry = 1,
}

export enum FoundryModelCapability {
	ChatCompletion = 0,
	Realtime = 1,
}
